import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../../environment';
import { Account } from '../../models/account.model';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: 'Sat, 01 Jan 2000 00:00:00 GMT',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class BankAccountClient {
  private http = inject(HttpClient);
  private env = inject(environment);
  private apiUrl = this.env.oregApiUrl + '/account';

  public getAccountList(worksiteId: string) {
    const url = `${this.apiUrl}/list/${worksiteId}`;
    return this.http.get<Account[]>(url, httpOptions);
  }

  public getAccount(accountId: string) {
    const url = `${this.apiUrl}/${accountId}`;
    return this.http.get<Account>(url, httpOptions);
  }

  public addAccount(account: Account) {
    const url = `${this.apiUrl}`;
    return this.http.post<Account>(url, account, httpOptions);
  }

  public deleteAccount(accountId: string) {
    const url = `${this.apiUrl}/${accountId}`;
    return this.http.delete(url, httpOptions);
  }

  public updateAccount(account: Account) {
    const url = `${this.apiUrl}`;
    return this.http.put<Account>(url, account, httpOptions);
  }

  public attesteraAccount(accountId: string) {
    const url = `${this.apiUrl}/${accountId}/attestera`;
    return this.http.put<void>(url, httpOptions);
  }

  public searchAccount(
    accountNumber: string,
    worksiteId: string,
    companyId: string,
  ) {
    const urlSuff = worksiteId
      ? `&worksiteId=${worksiteId}`
      : `&companyId=${companyId}`;
    const url = `${this.apiUrl}/search?accountNumber=${accountNumber}${urlSuff}`;
    return this.http.get<Account>(url, httpOptions);
  }
}
